export const CronJobsConfig = {
  option: {
    year: false,
  },
};
